/**
 * Container for an Video View component.
 */
import React from 'react'
import { connect } from 'react-redux'
import { Dispatch, AnyAction } from 'redux'

import { RootStoreState } from '../../root/index'
import { ScreenSectionItem } from '../../api/types'
import * as actions from '../actions'
import { FileType } from '../types'

export interface OwnProps {
	sectionItem: ScreenSectionItem
	isFullScreenModal?: boolean
	onBack?: () => void
	setFullScreenModal?: (status: boolean) => void
}

export interface Props {
	sectionItem: ScreenSectionItem
	videoFilePath?: string
	loadingVideoPath: boolean
}

export interface Actions {
	loadVideoPath: (fileName: string, url: string) => void
	clearVideoPath: (fileName: string) => void
}

const mapStateToProps = (state: RootStoreState, ownProps: OwnProps): Props => {
	const file = ownProps.sectionItem && ownProps.sectionItem.file
	const fileName = file && file.filename
	const filePath = fileName && state.screen.videoFilePaths.get(fileName)
	return {
		sectionItem: ownProps.sectionItem,
		videoFilePath: filePath,
		loadingVideoPath: !!fileName && state.screen.loadingVideoPaths.has(fileName),
	}
}

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>): Actions => ({
	loadVideoPath: (fileName: string, url: string) => {
		dispatch(actions.loadVideoPath({ type: FileType.VIDEO, fileName, url }))
	},
	clearVideoPath: (fileName: string) => {
		dispatch(actions.clearVideoPath(fileName))
	},
})

export default (Component: React.ComponentType<Props & Actions>) =>
	connect(mapStateToProps, mapDispatchToProps)(Component)
